export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const COMPATIBILITY_ADVISORY_API = '/api/mixes/compatibility-advisory';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };

// Agvise recommended minimum AMS load in hard water, lb/100 gallons.
export const DEFAULT_LABEL_MINIMUM_LB_PER_100_GAL = 8.5;
